export { default as RestaurantImage } from "./restaurant.webp";
export { default as RetailImage } from "./retail.jpeg";
export { default as TechnologyImage } from "./technology.jpeg";
export { default as ConsultingImage } from "./consulting.jpeg";
export { default as ConstructionImage } from "./construction.jpeg";
export { default as ECommerceImage } from "./ecommerce.webp";
export { default as ManufacturingImage } from "./manufacturing.jpeg";
export { default as TransportationImage } from "./transportation.jpeg";
export { default as HealthcareImage } from "./healthcare.webp";
export { default as HospitalityImage } from "./hospitality.webp";
export { default as FinancialImage } from "./finance.webp";
export { default as EducationImage } from "./education.webp";
export { default as MediaImage } from "./media.webp";
export { default as FashionImage } from "./fashion.webp";
export { default as AutomotiveImage } from "./automotive.jpeg";
export { default as AgricultureImage } from "./agriculture.jpeg";
